import { Button, List, ListItem, Typography } from '@mui/material'
import { BoxOrderContext } from 'contexts/BoxOrderContextProvider'
import { OrderContext } from 'contexts/OrderContextProvider'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

const PickClass = () => {
  const { boxItems, setSelectedClass, setRacks } = useContext(BoxOrderContext)
  const { setSelectedLocationId } = useContext(OrderContext)
  return (
    <>
      <Button
        variant='outlined'
        onClick={() => {
          setSelectedLocationId(null)
        }}
        sx={{
          margin: '20px'
        }}
      >
        Back
      </Button>
      <Typography variant='h3' sx={{ textAlign: 'center' }}>
        Pick a Class
      </Typography>
      {boxItems.length > 0 ? (
        <List
          sx={{
            '& .MuiListItemButton-root': {
              color: '#607998',
              fontFamily: 'sans-serif',
              fontWeight: 600
            },
            '& a': {
              textDecoration: 'none'
            }
          }}
        >
          {boxItems.map(thisItem => (
            <ListItem key={thisItem.class}>
              <Button
                variant='contained'
                sx={{
                  width: '100%',
                  textAlign: 'center',
                  textTransform: 'none',
                  fontSize: '26px',
                  padding: '50px 20px',
                  backgroundColor: '#364c63',
                  marginBottom: '20px'
                }}
                onClick={() => {
                  setSelectedClass(thisItem.class)
                  setRacks(
                    boxItems.find(item => item.class === thisItem.class).racks
                  )
                }}
              >
                {thisItem.class}
              </Button>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant='h3' textAlign='center' marginTop='30px'>
          No order found in this field!
        </Typography>
      )}
    </>
  )
}

export default PickClass
